import { simpleSuccessNotification } from 'hooks/notificationHandler'
import {
  SyncGoogleSheetPayItemConnectionInput,
  useSyncGoogleSheetPayItemConnectionMutation,
} from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'

export function useSyncGoogleSheetPayItemConnection(
  options?: Pick<SyncGoogleSheetPayItemConnectionInput, 'wait'>
) {
  const [sync] = useSyncGoogleSheetPayItemConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: options?.wait
      ? ({
          syncGoogleSheetPayItemConnection: {
            googleSheet: { title, compositeId },
          },
        }) =>
          simpleSuccessNotification(
            `${title ?? compositeId} successfully synced!`
          )
      : undefined,
  })
  return sync
}
